/**
 * SECURITY-PERFORMANCE-136-R1 — Telegram initData headers for Store V2 order/payment calls.
 * Never trusts client-supplied telegram_user_id; Worker verifies HMAC server-side.
 */
import { getTelegramInitData } from "../lib/telegram.js";

/** Headers for same-origin Store V2 proxies that must forward auth to the Worker. */
export function storeV2AuthHeaders(extra: Record<string, string> = {}): Record<string, string> {
  const headers: Record<string, string> = {
    Accept: "application/json",
    ...extra,
  };
  const initData = getTelegramInitData();
  if (initData) {
    headers.Authorization = `tma ${initData}`;
    headers["X-Telegram-Init-Data"] = initData;
  }
  return headers;
}
